import React, {Component} from 'react';
import cx from 'classnames';
import {FormattedMessage} from 'react-intl';

import './TencentCaptcha.scss';
import ScriptLoader from './ScriptLoader';
const APP_ID = '2045345034'

export default class TencentCaptcha extends Component {

  constructor(props, context) {
    super(props, context)
    this.state = { passed: false }
  }

  initCaptcha() {
    const option = {
      themeColor: '00A862', // apron-green
      type: 'embed'
    }
    this.captcha = new window.TencentCaptcha(
      this.captchaDom,
      APP_ID,
      this.callback.bind(this),
      option
    );
    this.captcha.show();
  }

  callback(retJson) {
    if (retJson.ret === 0) {
      this.setState({passed: true})
      this.props.onValidate({
        ticket: retJson.ticket,
        randstr: retJson.randstr
      })
    }
  }

  refreshCaptcha() {
    this.setState({ passed: false, }, () => {
      this.captcha.show()
    })
  }

  render() {
    const {passed} = this.state
    let wrapperClass = cx('item captchaWrapper', { 'validated': passed})

    return (
      <div className={wrapperClass}>
        {<ScriptLoader
          url="https://turing.captcha.qcloud.com/TCaptcha.js"
          onCreate={ () => false }
          onError={ () => false }
          onLoad={ this.initCaptcha.bind(this) }/>
        }
        {
          passed && <div className='passed flex justify-center'>
            <img className="padded-r-3" src="/assets/icons/icon-done.svg"/>
            <p className="apron-green"><FormattedMessage id="Verified"/></p>
          </div>
        }
        <div ref={(captchaDom) => { this.captchaDom = captchaDom } } style={{width: '300px', height: '230px', margin: '0 auto', position: 'relative', zIndex: '0'}}/>
      </div>
    )
  }
}
